import { render, staticRenderFns } from "./ChatWithQQ.vue?vue&type=template&id=563014af&scoped=true&"
import script from "./ChatWithQQ.vue?vue&type=script&lang=js&"
export * from "./ChatWithQQ.vue?vue&type=script&lang=js&"
import style0 from "./ChatWithQQ.vue?vue&type=style&index=0&id=563014af&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563014af",
  null
  
)

export default component.exports